import React from 'react';

interface StageVisualizationProps {
  name: string;
  height: number;
  width: number;
  icon?: JSX.Element | null;
}

export default function StageVisualization({
  name,
  height,
  width,
  icon,
}: StageVisualizationProps): JSX.Element {
  return (
    <div className="workflowVisualization-stage" style={{width, height}}>
      <div className="workflowVisualization-stage-header">
        <span className="workflowVisualization-stage-name">{name}</span>
        {icon}
      </div>
    </div>
  );
}
